module.exports = __webpack_public_path__ + "img/delete_bin_disabled.69decca1.svg";